import React from "react";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import SafeMakeTable from "./view/SafeMakeTable";

interface SafeMakeProps {}
export const SafeMake: React.FC<SafeMakeProps> = () => {
  const viewPermission =
    PERMISSIONS.permission_utilities_securityconfiguration_safemake_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return <> {userPermissions.includes(viewPermission) && <SafeMakeTable />} </>;
};
export default SafeMake;
